/**
 * Turnstile Key Validation Utilities
 *
 * Cloudflare Turnstile keys follow specific formats:
 * - Site keys: digit + 'x' + 20+ alphanumeric chars (e.g., 1x00000000000000000000AA)
 * - Secret keys: digit + 'x' + 30+ alphanumeric chars (e.g., 0x4AAAAAABbbbbCCCCCdddddEEEEEfffff)
 *
 * These validators help prevent password managers from auto-filling email/password
 * into the Turnstile key fields.
 */

// Valid Turnstile keys: start with digit + 'x' (e.g., 0x4AAAAAACEET7HF-wXuoF8O)
// We only check the prefix to prevent password manager auto-fill, not strict format validation
const TURNSTILE_KEY_PATTERN = /^[0-9]x/

export const isValidTurnstileSiteKey = (key: string | undefined | null): boolean => {
  if (!key) {
    return true
  } // Empty is valid (not configured)
  return TURNSTILE_KEY_PATTERN.test(key)
}

export const isValidTurnstileSecretKey = (key: string | undefined | null): boolean => {
  if (!key) {
    return true
  } // Empty is valid (not configured)
  return TURNSTILE_KEY_PATTERN.test(key)
}

export const getTurnstileSiteKeyError = (key: string | undefined | null): string | null => {
  if (!key) {
    return null
  }
  if (isValidTurnstileSiteKey(key)) {
    return null
  }
  return 'Invalid site key format. Valid keys start with a digit followed by "x" (e.g., "1x00000000000000000000AA"). A password manager may have auto-filled this field.'
}

export const getTurnstileSecretKeyError = (key: string | undefined | null): string | null => {
  if (!key) {
    return null
  }
  if (isValidTurnstileSecretKey(key)) {
    return null
  }
  return 'Invalid secret key format. Valid keys start with a digit followed by "x" (e.g., "0x4AAAAAABbbbbCCCCCdddddEEEEEfffff"). A password manager may have auto-filled this field.'
}
